import ReactMarkdown from "react-markdown";
import remarkGfm from "remark-gfm";
import { cn } from "@/lib/utils";

function normalizeAlertSummary(summary: string): string {
  return summary
    .trim()
    .replace(/\s*;\s*(?=\+\s)/g, "\n")
    .replace(/\s+(?=\+\s)/g, "\n")
    .replace(/(^|\n)\+\s/g, "$1- ");
}

export function AlertSummary({ summary, className }: { summary: string; className?: string }) {
  return (
    <ReactMarkdown
      remarkPlugins={[remarkGfm]}
      className={cn("space-y-2", className)}
      components={{
        p: ({ children }) => <p>{children}</p>,
        ul: ({ children }) => <ul className="list-disc space-y-1 pl-4">{children}</ul>,
        ol: ({ children }) => <ol className="list-decimal space-y-1 pl-4">{children}</ol>,
        strong: ({ children }) => <strong className="font-semibold text-foreground">{children}</strong>,
        a: ({ children, href }) => <a href={href} className="underline underline-offset-2 hover:text-foreground">{children}</a>,
      }}
    >
      {normalizeAlertSummary(summary)}
    </ReactMarkdown>
  );
}